export default function Corners({ color = "#C9A84C", size = 14, className = "" }) {
  const s = size;
  return (
    <svg
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      aria-hidden
    >
      <g fill="none" stroke={color} strokeWidth="1" vectorEffect="non-scaling-stroke">
        {/* top-left */}
        <path d={`M0,${s} L0,0 L${s},0`} />
        {/* top-right */}
        <path d={`M${100 - s},0 L100,0 L100,${s}`} />
        {/* bottom-left */}
        <path d={`M0,${100 - s} L0,100 L${s},100`} />
        {/* bottom-right */}
        <path d={`M${100 - s},100 L100,100 L100,${100 - s}`} />
      </g>
    </svg>
  );
}
